'use client';
/**
 * The templates the wizard offers, fetched once per page. `null` until loaded
 * or when templates are unavailable — callers then use their built-in lists.
 */
import { useEffect, useState } from 'react';
import { offeredTemplates, type OfferedTemplates } from '../actions/offeredTemplates';

let cache: Promise<OfferedTemplates | null> | null = null;

export function useOfferedTemplates(): OfferedTemplates | null {
  const [value, setValue] = useState<OfferedTemplates | null>(null);
  useEffect(() => {
    let alive = true;
    cache ??= offeredTemplates().catch(() => null);
    cache.then((v) => { if (alive) setValue(v); });
    return () => { alive = false; };
  }, []);
  return value;
}

/** A template title in the UI locale, falling back to Russian, then English. */
export function templateTitle(title: Record<string, string> | undefined, locale: string): string | null {
  if (!title) return null;
  return title[locale] || title.ru || title.en || null;
}
